import Api from '../api';

let cachedToken = null;
let tokenExpirationTime = 0;

const isCachedTokenValid = () => {
  if (!cachedToken) return false;
  return Math.floor(Date.now() / 1000) < tokenExpirationTime;
};

/**
 * Obtém o token de acesso do Foundry via backend (client_credentials).
 * O backend renova sozinho; o cache aqui evita uma ida por mensagem.
 */
export const getAzureToken = async () => {
  if (isCachedTokenValid()) {
    return cachedToken;
  }

  const resp = await Api.post('/api/chat/azure-token');
  const data = resp?.data || {};
  const token = data.accessToken || data.token;

  if (!token) {
    throw new Error('Backend não retornou token de acesso do Foundry');
  }

  const expiresIn = Number(data.expiresIn) || 3600;
  cachedToken = token;
  tokenExpirationTime = Math.floor(Date.now() / 1000) + expiresIn - 300; // buffer 5 min
  return token;
};
